import * as method from './method'

export default {
  method
}



// WEBPACK FOOTER //
// ./src/api/api.js